import { IClientsCategories, IClientsCategoriesListItem, ClientsCategoriesResponseType } from "@/entity/clients/clientsCategories.types";

export default class ClientsCategories implements  IClientsCategories {
    total: number;
    data: IClientsCategoriesListItem[] = [];
    constructor(data: ClientsCategoriesResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}